import { chrome } from "../theme/tokens";

// Shared nav row styles: the room drawer and the staff room switcher use the
// same rows, so a page link and a room link read alike.
export function menuItemSx(active: boolean, expanded: boolean) {
    return {
        p: 1,
        gap: 1,
        mb: 0.5,
        width: "100%",
        borderRadius: 1,
        minHeight: 40,
        justifyContent: expanded ? "flex-start" : "center",
        fontSize: 13,
        lineHeight: "20px",
        fontWeight: 500,
        whiteSpace: "normal",
        overflowWrap: "break-word",
        color: active ? chrome.ink : chrome.inkBody,
        "&.Mui-selected, &.Mui-selected:hover": { backgroundColor: chrome.surfaceActive },
        "&:hover": { backgroundColor: chrome.surfaceHover },
    } as const;
}

// `!important` on minWidth is required: MenuItem ships a
// `.MuiMenuItem-root .MuiListItemIcon-root { min-width: 36px }` rule whose
// specificity beats a plain sx, which would keep the 36px icon box and
// left-align the glyph in the collapsed rail. Forcing auto shrinks the box to
// the icon so the MenuItem's justifyContent:center actually centers it.
export const iconSx = {
    minWidth: "auto !important",
    justifyContent: "center",
    color: chrome.iconPrimary,
    "& > svg": { width: "20px !important", height: "20px !important" },
} as const;

export function labelProps(active: boolean) {
    return {
        fontSize: 13,
        lineHeight: "20px",
        fontWeight: 500,
        color: active ? chrome.ink : chrome.inkBody,
        sx: { whiteSpace: "normal", overflowWrap: "break-word" },
    } as const;
}
